import api from "../api";

const verifyAccount= async (phone,verifyCode) => {
  const requestData = {
    "phone": phone,
    "code":verifyCode
  }
    try {

      const response = await api.post(process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT + "/app/auth/login-by-sms-verify", requestData);
      return response.data;
    }
     catch (error) {
      console.error('There was a problem with the axios operation:', error);
      throw error;
    }
  
}

export default verifyAccount;
